import { getCurrentAdViewportType } from '@utils/ads'
import { useEffect, useState } from 'react'
import useViewportType from './useViewportType'

const useAdViewport = (): 'desktop' | 'mobile' | '' => {
  const viewportType = useViewportType()
  const [adViewport, setAdViewport] = useState<'desktop' | 'mobile' | ''>('')

  useEffect(() => {
    const adViewportType = getCurrentAdViewportType()

    if (!!adViewportType) {
      if (adViewportType === 'desktop') {
        setAdViewport('desktop')
      } else if (adViewportType === 'mobile') {
        setAdViewport('mobile')
      } else {
        setAdViewport('')
      }
    }

    //! We need the 'viewportType` dependency so that we re-render
    //! the component (even if it's not explicitly used)
  }, [viewportType])

  return adViewport
}

export default useAdViewport
